import React from 'react';
import axios from 'helpers/axios';

import { Container, Title, Button } from 'ui/components/styled';
import { Modal } from 'ui/components/styled/NewModal';
import { useCompany, useMutableRef } from 'hooks';
import { ReorderCategories } from '../lists';
import { Loader } from '../lists/styled';

export const ReorderModal = ({ show, onRefresh, onClose }) => {
  const [categories, setCategories] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [preventSave, setPreventSave] = React.useState(true);
  const [preventDrag, setPreventDrag] = React.useState(false);
  const [order, setOrder] = useMutableRef([]);
  const { activeCompany } = useCompany();

  const fetchCategories = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `/jobs/categories/?$top=-1&$cid=${activeCompany}&$select=name,company`
      );

      if (response.status === 200) {
        setCategories(response.data.value);
      }
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };

  React.useEffect(() => {
    if (show) {
      fetchCategories();
    }
  }, [show]);

  const handleChange = (categories) => {
    const newOrder = categories.map((category, index) => ({
      id: category.id,
      position: index + 1,
    }));
    setOrder(newOrder);
    setPreventSave(false);
  };

  const handleSave = async () => {
    setPreventSave(true);
    setPreventDrag(true);

    try {
      const response = await axios.post('/jobs/categories/reorder/', { order: order.current });

      if (response.status === 200) {
        onRefresh();
        onClose();
      }
    } catch (error) {
      console.error(error);
      setPreventSave(false);
    }

    setPreventDrag(false);
  };

  return (
    <Modal isOpen={show} onRequestClose={onClose}>
      <Container mb="l">
        <Title variant="primary" fontSize="20px" fontWeight="500">
          Reorder categories
        </Title>
      </Container>
      <Container mb="s">
        {show && (
          <>
            {loading ? (
              <Loader />
            ) : (
              <ReorderCategories
                categories={categories}
                isDraggable={!preventDrag}
                onChange={handleChange}
              />
            )}
          </>
        )}
      </Container>
      <Container flexDirection="row" justifyContent="flex-end">
        <Button variant="contrast-primary" width="180px" onClick={onClose} boxShadow="none" mr="s">
          Close
        </Button>
        <Button type="submit" width="180px" onClick={handleSave} disabled={preventSave}>
          Save
        </Button>
      </Container>
    </Modal>
  );
};
